export enum  UploadType{
    ftp = 1,
    website = 2
}